import api from "./api";
import { getSucursalInfo } from "./auth";

// Ported from sge_infantil_web/src/pages/user/{create,edit,maintain}/index.js.
// services/user.ts in the original is dead/legacy (mock data, non-existent
// umi endpoints) — the real screens call `services/api.js` directly, same
// pattern as worker.js/teacher.js in this repo.
export async function listProfiles() {
  const sucursalId = getSucursalInfo()?.id || 1;
  return api.get(`/api/profile/${sucursalId}`);
}

// The "Lista de Utilizadores" screen (maintain/index.js) hits
// `/api/user/all/{sucursalId}` — NOT `/api/user/{sucursalId}` as originally
// guessed. Each returned user has `profile: { description }` nested.
export async function listUsers() {
  const sucursalId = getSucursalInfo()?.id || 1;
  return api.get(`/api/user/all/${sucursalId}`);
}

export async function createUser(payload) {
  return api.post("/api/user", payload);
}

export async function updateUser(id, payload) {
  return api.put(`/api/user/${id}`, payload);
}

export async function activateUser(id, updatedBy) {
  return api.put(`/api/user/activate/${id}`, { updatedBy });
}

export async function inactivateUser(id, updatedBy) {
  return api.put(`/api/user/inactivate/${id}`, { updatedBy });
}

// Ported from maintain/index.js `handleResetPassword`.
export async function resetUserPassword(id, updatedBy) {
  return api.put(`/api/user/reset-password/${id}`, { updatedBy });
}

// Ported from GlobalHeader/AvatarDropdown.tsx `handleChangePassword` (the
// "Trocar Senha" header option in sge_infantil_web) — same endpoint used by
// the first-login password step in SignInLayer. Unlike resetUserPassword
// (admin-triggered, no password value), this lets the logged-in user set
// their own new password.
export async function changeUserPassword(id, password, updatedBy) {
  return api.put(`/api/user/password/${id}`, { password, updatedBy });
}
